/**
 * Social Media Icon Components
 * Thin wrappers around lucide-react for the brand icons used in the
 * footer and social sections. They preserve a stable component identity
 * so callers can keep using <GitHubIcon />, <LinkedInIcon />, and
 * <EmailIcon /> without coupling to the icon library.
 */

import { Github, Linkedin, Mail } from 'lucide-react'

interface IconProps {
  className?: string
  size?: number
}

export function GitHubIcon({ className = '', size = 18 }: IconProps) {
  return <Github className={className} size={size} aria-hidden="true" />
}

export function LinkedInIcon({ className = '', size = 18 }: IconProps) {
  return <Linkedin className={className} size={size} aria-hidden="true" />
}

export function EmailIcon({ className = '', size = 18 }: IconProps) {
  return <Mail className={className} size={size} aria-hidden="true" />
}
